import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=09818c84&scoped=true&"
import script from "./AccountSetting.vue?vue&type=script&lang=ts&"
export * from "./AccountSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09818c84",
  null
  
)

export default component.exports